// https://composition-api.nuxtjs.org/typings/definitionHelpers#definenuxtmiddleware
export default defineNuxtRouteMiddleware(() => {
  const $pinia = usePinia()
  const authStore = useAuthStore($pinia)

  if (authStore.isLogin) {
    return navigateTo(URL_MAP.ARTIST)
  }
})
